/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useContext } from 'react';
import { number, shape, string } from 'prop-types';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { ReorderRecommendations } from '@thd-olt-component-react/thd-recs-containers';
import { Card, CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { BuyAgain } from '@thd-olt-component-react/buy-again';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from '../context/HomepageContext';

export function BuyItAgain({
  REQUEST_KEY, id, brandTitleMaxLine, slidesPer, storefront, customerType, buyAgainBreakpoints
}) {
  const { defaultVariables } = useContext(QueryContext);
  const { defaultCardClass, isB2C } = useContext(HomepageContext);

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant
      === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <ErrorBoundary name="reorder-recognized-homepage">
      <QueryProvider
        cacheKey="reorder-recognized-homepage"
        defaultVariables={newDefaultVariables}
      >
        {customerType === 'b2b'
          ? (
            <BuyAgain
              brandTitleMaxLine={2}
              slidesToShow={buyAgainBreakpoints}
              hideTitle
              noATCFulfillment
              requestKey={REQUEST_KEY}
              showFallback
              showLoading
              entryId={id}
              storefrontSvocId={storefront?.SVOCID}
              showHybridCarousel
            />
          )
          : (
            <Card
              id={`buy-it-again-php-${id}`}
              className={defaultCardClass}
              CardContentProps={{ className: 'sui-flex sui-flex-col sui-w-full sui-h-full sui-gap-4 sui-p-4' }}
            >
              <CardTitle
                header={
                  <Typography variant="h3">Buy It Again</Typography>
                }
              />
              <ReorderRecommendations
                brandTitleMaxLine={brandTitleMaxLine}
                slidesPer={slidesPer}
                hideTitle
                noATCFulfillment
                requestKey={REQUEST_KEY}
                showFallback
                showLoading
                entryId={id}
                storefrontSvocId={storefront?.SVOCID}
                enableRoundedProductImages={isB2C}
              />
            </Card>
          )}
      </QueryProvider>
    </ErrorBoundary>
  );
}

BuyItAgain.propTypes = {
  REQUEST_KEY: string,
  id: string,
  brandTitleMaxLine: number,
  slidesPer: number,
  storefront: shape({
    SVOCID: string,
  }),
  customerType: string,
  buyAgainBreakpoints: shape({
    sm: number,
    md: number,
    lg: number,
    xl: number,
    '2xl': number,
  }),
};

BuyItAgain.defaultProps = {
  REQUEST_KEY: undefined,
  id: undefined,
  brandTitleMaxLine: undefined,
  slidesPer: undefined,
  storefront: null,
  customerType: undefined,
  buyAgainBreakpoints: undefined,
};
